import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="label-eyebrow">AUDIT TRAIL</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold uppercase tracking-tight mt-1">System Log</h1>
      </div>
      <Card className="rounded-none bg-[#0a0a0a] border-[#1c1c1c] overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="text-[#666] label-eyebrow border-b border-[#1c1c1c]">
              <th className="px-4 py-3 text-left font-normal">TIME</th>
              <th className="px-4 py-3 text-left font-normal">ACTOR</th>
              <th className="px-4 py-3 text-left font-normal">ACTION</th>
              <th className="px-4 py-3 text-left font-normal">ENTITY</th>
              <th className="px-4 py-3 text-left font-normal">DETAIL</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-[#1c1c1c] hover:bg-[#101010]">
                <td className="px-4 py-3 font-mono tabular text-xs">{new Date(l.at).toLocaleString()}</td>
                <td className="px-4 py-3 font-mono text-xs">{l.actor_email}</td>
                <td className="px-4 py-3"><span className="label-eyebrow">{l.action}</span></td>
                <td className="px-4 py-3 font-mono text-xs">{l.entity}</td>
                <td className="px-4 py-3 text-[#aaa]">{l.detail}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="text-center py-10 font-mono text-[#666]">NO ENTRIES</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
